import type { ComponentProps } from 'react'
import { useTranslation } from 'react-i18next'
import { Base } from '@itsrever/design-system'
import { datePresets } from './presets'

const { DatePicker } = Base

type DatePickerProps = ComponentProps<typeof DatePicker>

interface DateRangePickerProps {
  selected: DatePickerProps['selected']
  onSelect: DatePickerProps['onSelect']
}

export function DateRangePicker({ selected, onSelect }: DateRangePickerProps) {
  const { t } = useTranslation()
  return (
    <DatePicker
      mode="range"
      selected={selected}
      disabled={{ after: new Date() }}
      onSelect={onSelect}
      placeholder={t('date_range.select_date_range')}
      presets={datePresets(t)}
    />
  )
}
